import { createPageStore } from 'common/store';
import { INITIAL_STATE } from './constants';
export var useCustomizationStore = createPageStore({
    initialValues: INITIAL_STATE,
});
